export const toDropdownItemGroup = (mediaResult, query, t, excludeGroup = []) => {
  const groups = [];
  if (mediaResult && mediaResult.aggregations) {
    if (!excludeGroup.includes('mediaType')) {
      const mediaTypes = mediaResult.aggregations.mediaTypes.map(mediaType => ({
        id: mediaType.mediaType,
        title: t(`search.mediaType.${mediaType.mediaType}`),
        count: mediaType.count
      }));
      groups.push({
        id: 'mediaType',
        items: mediaTypes,
        selectedItems: query.mediaType ? [query.mediaType] : [],
        singleSelection: true
      });
    }
    if (!excludeGroup.includes('mediaProperty')) {
      const properties = mediaResult.aggregations.properties.map(property => ({
        id: property.type,
        title: t(`search.property.${property.type}`),
        count: property.count
      }));
      groups.push({
        id: 'mediaProperty',
        items: properties,
        selectedItems: query.mediaProperties || [],
        singleSelection: false
      });
    }
    if (!excludeGroup.includes('mediaDuration')) {
      const durations = mediaResult.aggregations.duration.map(duration => ({
        id: duration.duration,
        title: t(`search.${duration.duration}`),
        count: duration.count
      }));
      groups.push({
        id: 'mediaDuration',
        items: durations,
        selectedItems: query.duration ? [query.duration] : [],
        singleSelection: true
      });
    }
  }
  return groups;
};
export const getActivePropertyFilters = groups => {
  const activeFilters = {
    mediaProperties: []
  };
  const mediaTypeGroup = groups.find(group => group.id === 'mediaType');
  if (mediaTypeGroup && mediaTypeGroup.selectedItems.length > 0) {
    activeFilters.mediaType = mediaTypeGroup.selectedItems[0];
  }
  const mediaPropertyGroup = groups.find(group => group.id === 'mediaProperty');
  if (mediaPropertyGroup && mediaPropertyGroup.selectedItems.length > 0) {
    activeFilters.mediaProperties = mediaPropertyGroup.selectedItems;
  }
  const mediaDurationGroup = groups.find(group => group.id === 'mediaDuration');
  if (mediaDurationGroup && mediaDurationGroup.selectedItems.length > 0) {
    activeFilters.duration = mediaDurationGroup.selectedItems[0];
  }
  return activeFilters;
};